<template>
  <div>
    <div class="mt-6">
      <label for="project-url" class="label">Share this link with your users:</label>
      <div 
        class="relative mt-2 p-1 rounded transition-colors duration-200"
      >
        <input
          type="text"
          id="project-url"
          :value="projectUrl"
          readonly
          class="input w-full pr-10"
          :class="{ 'bg-emerald-100 border-emerald-500 text-emerald-600': showCopiedMessage }"
        />
        <button
          @click="copyProjectUrl"
          class="absolute right-2 top-1/2 transform -translate-y-1/2 p-2"
          :class="{ 'text-emerald-600': showCopiedMessage, 'text-gray-400': !showCopiedMessage }"
          title="Copy URL"
        >
          <simple-svg
            :filepath="showCopiedMessage ? Check : copyTextIcon"
            :width="'20px'"
            :height="'20px'"
          ></simple-svg>
        </button>
      </div>
    </div>
    <form action="#" class="mt-8" @submit.prevent="openProject()">
      <div class="mt-8">
        <button
          type="submit"
          class="w-full bg-[#F54239] flex items-center justify-center min-h-[48px] text-white py-3 px-4 rounded-xl font-medium hover:brightness-95 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Go to your project
          <simple-svg
            :filepath="NextIcon"
            :width="'20px'"
            :height="'20px'"
            class="ml-1"
          ></simple-svg>
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import NextIcon from "../images/icons/arrow-right.svg";
import copyTextIcon from "../images/icons/copy-text.svg";
import Check from "images/icons/check.svg"

export default {
  props: ["project"],

  data() {
    return {
      NextIcon,
      copyTextIcon,
      Check,
      showCopiedMessage: false,
    };
  },

  methods: {
    openProject() {
      window.location.replace(this.projectUrl+"?track_signup=true");
    },
    copyProjectUrl() {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(this.projectUrl)
          .then(() => {
            this.showCopiedMessage = true;
            setTimeout(() => {
              this.showCopiedMessage = false;
            }, 2000);
          })
          .catch(err => {
            this.fallbackCopyToClipboard();
          });
      } else {
        this.fallbackCopyToClipboard();
      }
    },

    fallbackCopyToClipboard() {
      const textArea = document.createElement("textarea");
      textArea.value = this.projectUrl;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        document.execCommand('copy');
        this.showCopiedMessage = true;
        setTimeout(() => {
          this.showCopiedMessage = false;
        }, 2000);
      } catch (err) {
        console.error('Fallback: Unable to copy to clipboard', err);
      }

      document.body.removeChild(textArea);
    }
  },

  computed: {
  projectUrl() {
    const protocol = window.location.protocol;
    const host = window.location.host;
    const rootDomain = document.querySelector('meta[name="root-domain"]')?.content || host;

    const domainParts = rootDomain.split('.');
    const cleanDomain = domainParts.length > 2 ? domainParts.slice(-2).join('.') : rootDomain;

    return `${protocol}//${this.project.url}.${cleanDomain}`;
  },
},
};
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
